import React, { useEffect } from "react";
import parse from "html-react-parser";
import gsap from "gsap";
import Div from "../Div";           // 🔥 Make sure this path is correct
import "./hero.scss";


export default function Hero({ title, subtitle }) {

  useEffect(() => {

    const animateCircle = (
      selector,
      distance = 300,
      speed = 4,
      blur = 100,
      scalePower = 1.6
    ) => {
      const el = document.querySelector(selector);

      if (!el) return;

      // 🔥 1. INFINITE MOTION LOOP (NO Y0Y0, NO REPEAT)
      const loopMove = () => {
        gsap.to(el, {
          x: gsap.utils.random(-distance, distance),
          y: gsap.utils.random(-distance, distance),
          scale: gsap.utils.random(1.1, scalePower),
          rotate: gsap.utils.random(-45, 45),
          duration: gsap.utils.random(speed * 0.6, speed * 1.4),
          ease: "power2.inOut",
          filter: `blur(${gsap.utils.random(blur * 0.7, blur * 1.2)}px)`,
          onComplete: loopMove, // SUPER-SMOOTH infinite loop
          force3D: true,
        });
      };

      loopMove(); // Start infinite loop


      // 🔥 2. PREMIUM OPACITY GLOW (Soft Pulse)
      gsap.timeline({ repeat: -1, yoyo: true })
        .to(el, {
          opacity: 0.75,
          duration: gsap.utils.random(2, 4),
          ease: "sine.inOut",
        })
        .to(el, {
          opacity: 1,
          duration: gsap.utils.random(2, 4),
          ease: "sine.inOut",
        });


      // 🔥 3. DEPTH PARALLAX (3D Floating)
      gsap.to(el, {
        z: gsap.utils.random(-150, 150),
        duration: gsap.utils.random(4, 7),
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut",
      });


      // 🔥 4. ROTATION DRIFT (Cinematic Slow Rotation)
      gsap.to(el, {
        rotateZ: gsap.utils.random(-20, 20),
        duration: gsap.utils.random(5, 9),
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });
    };


    // APPLY SUPER PREMIUM ANIMATION TO ALL CIRCLES
    animateCircle(".circle._1", 370, 3.5, 90, 1.55);
    animateCircle(".circle._2", 430, 4.2, 120, 1.65);
    animateCircle(".circle._3", 350, 3.2, 85, 1.48);
    animateCircle(".circle._4", 480, 4.5, 150, 1.8);

  }, []);


  return (
  <Div className="hero-section">
    {/* Background Circles + FX Layer */}
    <div className="gradient-wrapper">
      <div className="circle _1"></div>
      <div className="circle _2"></div>
      <div className="circle _3"></div>
      <div className="circle _4"></div>

      {/* 🫧 Particle Layer */}
      <div className="hero-particles">
        {Array.from({ length: 24 }).map((_, i) => (
          <span key={i} className="hero-particle" />
        ))}
      </div>

      {/* 🎇 Lens Flare */}
      <div className="hero-lensflare" />
    </div>

    {/* Hero Content */}
    <div className="hero_component">
      <div className="container-new home-marquee">
        <div className="hero-wrapper-4">
          <h1 className="hero-heading-2">{parse(title)}</h1>
          <div className="text-large max-width-616px align-center">
            {subtitle}
          </div>

          {/* If you want ReelMarquee inside hero */}
          {/* <div className="hero-reel-wrapper">
            <ReelMarquee />
          </div> */}
        </div>
      </div>
    </div>
  </Div>

  );
}
